import * as Scrivito from "scrivito";
import metadataAttributes from "../_metadataAttributes";
import defaultPageAttributes from "../_defaultPageAttributes";

const CourseOverviewPage = Scrivito.provideObjClass("CourseOverviewPage", {
  attributes: {
    ...defaultPageAttributes,
    body: ["widgetlist", { only: "SectionContentWidget" }],
    ...metadataAttributes,
    navigationIcon: "string",
    introduction: "string",
  },
  extractTextAttributes: ["body", "title", "segmentName"],
});

export default CourseOverviewPage;
